import { render } from "./Summary.ce.vue?vue&type=template&id=c4fedae2"
import script from "./Summary.ce.vue?vue&type=script&lang=js"
export * from "./Summary.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__